import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import TrainerList from 'components/fragments/TrainerList/TrainerList';
const TrainerListComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/TrainerList/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <TrainerList {...props} />
  </ImagesProvider>
);

export default TrainerListComponent;
